export const typeOfCourseWeight = (translate) => {
  return {
    [translate('app.message.coursesTypes.courseDiscovery')]: 4,
    [translate('app.message.coursesTypes.courseLearning')]: 3,
    [translate('app.message.coursesTypes.courseImmersion')]: 2,
    [translate('app.message.coursesTypes.courseMentoring')]: 1,
  };
};